/**
 * The dark tooltip over a hovered week. It carries the numbers the stack can only show as
 * proportions — and, in the levelled view, the still-queued hours, which are drawn capped
 * so a huge backlog cannot blow the axis. The cap is why the number has to be here.
 */

import React from 'react'
import type { WeekModel } from '../../viewmodels/loading'
import { hrs, weekFull } from './format'

function rowsOf(w: WeekModel, levelled: boolean): [string, string][] {
  if (!levelled) {
    return [
      ['scheduled', hrs(w.scheduled)],
      ['capacity', hrs(w.capacity)],
      ['load', w.loadPct == null ? '—' : `${Math.round(w.loadPct)}%`],
    ]
  }
  return [
    ['clearing', hrs(w.clearing)],
    ['due this week', hrs(w.own)],
    ['free', hrs(w.free)],
    ['still queued', hrs(w.carry)],
  ]
}

export default function ColumnTooltip({ week, levelled }: {
  week: WeekModel
  levelled: boolean
}): React.JSX.Element {
  return (
    <div
      role="tooltip"
      className="pointer-events-none absolute bottom-full left-1/2 z-20 min-w-[158px] -translate-x-1/2 -translate-y-2 rounded-md px-[9px] py-[7px] font-mono text-[10px] font-medium"
      style={{ background: 'var(--lc-tip)', boxShadow: '0 6px 18px rgba(15,23,42,.28)' }}
    >
      <div className="flex justify-between gap-3.5">
        <span style={{ color: 'var(--lc-mut)' }}>{weekFull(week.weekStart)}</span>
      </div>
      {rowsOf(week, levelled).map(([k, v]) => (
        <div key={k} className="flex justify-between gap-3.5">
          <span style={{ color: 'var(--lc-mut)' }}>{k}</span>
          <span className="tabular-nums" style={{ color: '#e2e8f0' }}>{v}</span>
        </div>
      ))}
      <div
        className="mt-1 border-t pt-[5px]"
        style={{ borderColor: 'rgba(255,255,255,.13)', color: 'var(--lc-teal-ink)' }}
      >
        click to open this week ↗
      </div>
    </div>
  )
}
